var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"order-notice"},[(_vm.richTextContent)?_c('div',{staticClass:"rich-text-content",domProps:{"innerHTML":_vm._s(_vm.richTextContent)}}):_vm._e(),(_vm.footerText)?_c('div',{staticClass:"footer-notice",domProps:{"innerHTML":_vm._s(_vm.footerText)}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }